
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35115',
  depVersions: {
  "documents-public-ui": "static-1.35115",
  "atom": "static-1.5331",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2744",
  "client-types": "static-1.490",
  "cssUtils": "static-1.870",
  "customer-data-filters-ui": "static-1.40757",
  "customer-data-objects": "static-1.7934",
  "customer-data-property-utils": "static-1.8345",
  "documents-lib": "static-1.35120",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.360",
  "FormsCommonComponents": "static-1.86478",
  "FormUrlGenerator": "static-2.4973",
  "foundations-theming-specialty": "static-1.2419",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.108",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5843",
  "hs-test-utils": "static-1.8274",
  "hub-http": "static-1.6459",
  "hubspot-dlb": "static-2.1882",
  "HubStyle": "static-2.12037",
  "HubStyleTokens": "static-2.11730",
  "I18n": "static-7.1661",
  "icons": "static-2.674",
  "jasmine-immutable": "static-1.3270",
  "jasmine-runner": "static-1.6696",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7399",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3144",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5641",
  "quartz": "static-1.7366",
  "react": "static-7.190",
  "react-dlb": "static-1.84",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1-unify-reporter-duration-calculations.6",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5516",
  "react-virtualized": "static-2.104",
  "reference-resolvers": "static-1.8429",
  "reference-resolvers-lite": "static-1.8346",
  "reporting-data": "static-1.68579",
  "reporting-reports": "static-1.68257",
  "reporting-snowflake": "static-1.57197",
  "reporting-testing-lib": "static-1.10512",
  "reporting-visualizations": "static-1.60655",
  "reselect": "static-3.9",
  "sales-content-partitioning": "static-1.9195",
  "sanitize": "static-1.4722",
  "sanitize-text": "static-1.8397",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1993",
  "signup-constants": "static-1.19490",
  "signup-ui-url-generator": "static-2.8306",
  "StyleGuideUI": "static-3.495",
  "superstore": "static-1.5005",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.5003",
  "ui-addon-form-validation": "static-1.11233",
  "ui-asset-management-lib": "static-1.11343",
  "ui-images": "static-2.1229",
  "UIComponents": "static-3.8676",
  "usage-tracker": "static-1.7603",
  "usage-tracker-container": "static-1.7593",
  "usage-tracker-core": "static-1.7453",
  "viral-links-lib": "static-1.7321",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9904",
  "foundations-components": "static-1.8386",
  "immutable": "static-2.83",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1144",
  "quartz-core": "static-1.6585",
  "quick-fetch": "static-1.4093",
  "raven": "static-3.5925",
  "redux": "static-4.76",
  "redux-thunk": "static-2.77",
  "rpc-client-utils": "static-1.4909",
  "ui-addon-i18n": "static-1.11393",
  "ui-addon-upgrades": "static-9.18319",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3575",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3643",
  "quartz-webpack": "static-1.3590",
  "foundations-assets": "static-1.5123",
  "foundations-theming": "static-1.4703",
  "hub-http-shared-msw-handlers": "static-1.10526",
  "hubspotter-http": "static-1.4825",
  "sassPrefix": "static-1.161",
  "conversations-skeleton-state": "static-1.7495",
  "crm-message-bus": "static-1.43640",
  "customer-data-filters-ui-msw-helpers": "static-1.23192",
  "customer-data-objects-ui-components": "static-1.13277",
  "customer-data-reference-ui-components": "static-1.13427",
  "customer-data-ui-utilities": "static-1.10073",
  "events-data-lib": "static-1.489",
  "framework-builder-read-service-client": "static-1.4182",
  "hs-resources": "static-1.437",
  "immer": "static-1.94",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.4018",
  "multi-account-reference-resolvers": "static-1.1243",
  "onboarding-scopes": "static-1.6704",
  "onboarding-tours": "static-1.17039",
  "pulse": "static-1.873",
  "reporting-datasets-permissions-lib": "static-1.14365",
  "stylex": "static-1.38",
  "trellis-assets": "static-1.2469",
  "trellis-components": "static-1.2488",
  "trellis-theming": "static-1.1208",
  "ui-addon-teams": "static-1.21853",
  "quartz-auth": "static-1.1041",
  "ui-business-units-lib": "static-1.9329",
  "usage-tracker-session-replay": "static-1.5289",
  "ai-components-ui-library": "static-1.9580",
  "ContentUtils": "static-1.69054",
  "customer-data-properties": "static-1.52426",
  "forms-ai-lib": "static-1.4687",
  "forms-utils-lib": "static-1.13018",
  "foundations-components-test-utils": "static-1.5869",
  "react-dnd-compat": "static-1.4863",
  "react-tinymce": "static-1.55873",
  "tinymce-config": "static-2.54999",
  "ui-gdpr-components": "static-1.10601",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3688",
  "HeadJS": "static-2.789",
  "framer-motion": "static-1.76",
  "hs-test-utils-bend-plugin": "static-1.3385",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "hs-locale-management": "static-1.255",
  "ui-fonts": "static-1.992",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4565",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1031",
  "web-vitals": "static-1.11",
  "batch-promise": "static-1.1791",
  "external-options-client-types": "static-1.4301",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7141",
  "quartz-i18n": "static-1.1041",
  "frontend-preferences-client": "static-1.8174",
  "graphql": "static-1.86",
  "persist-promise": "static-1.3948",
  "reporting-client-types": "static-1.2651",
  "apollo-stack-hubspot": "static-3.90",
  "growth-payments-core": "static-1.26072",
  "hubspot-apollo-client": "static-1.5125",
  "foundations-components-legacy": "static-1.1411",
  "quartz-routing": "static-1.796",
  "hs-story-utils": "static-1.9674",
  "react-flip-move": "static-1.75",
  "nested-table": "static-1.480",
  "seat-types-lib": "static-1.611",
  "timezone-utils": "static-2.5495",
  "react-create-root-preference": "static-1.60",
  "bend-plugin-foundations-components": "static-1.4655",
  "floating-ui": "static-1.61",
  "react-aria": "static-1.70",
  "tanstack-table": "static-1.59",
  "dispatcher": "static-1.141",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.867",
  "mobile-manifest-mixins": "static-1.565",
  "module-federation": "static-1.30",
  "quartz-test": "static-1.1041",
  "quartz-tracking": "static-1.745",
  "bend-plugin-chirp-manifest": "static-1.319",
  "chirp-fetch": "static-1.2138",
  "merchandise-lib": "static-1.273",
  "purchase-motions-components": "static-1.6282",
  "salesImages": "static-1.530",
  "ts-schema": "static-1.4255",
  "bender-build-tools": "static-1.3358",
  "bend-plugin-foundations-theming": "static-1.3186",
  "restore-request-side-panel-lib": "static-1.1553",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.4903",
  "conditional-properties-service-client": "static-1.3976",
  "crm-pipelines-api-client-types": "static-1.4309",
  "event-emitter": "static-1.1201",
  "fdsr-migration-layer": "static-1.260",
  "multi-currency-client-types": "static-1.3869",
  "getting-started-shared-tasks": "static-1.19112",
  "growth-data-modal": "static-1.5818",
  "growth-onboarding-confetti": "static-1.3308",
  "growth-onboarding-next-action-utils": "static-1.2594",
  "navigation-components": "static-1.18712",
  "onboarding-tours-client": "static-1.5253",
  "onboarding-tours-utils": "static-1.1105",
  "ui-shepherd-react": "static-3.10510",
  "ui-shepherd-tracker": "static-1.7891",
  "ui-universal-auth": "static-1.9287",
  "user-context": "static-1.5359",
  "bend-plugin-pulse": "static-1.376",
  "fast-json-patch": "static-1.67",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "tanstack-virtual": "static-1.36",
  "hubspotter-http-shared-msw-handlers": "static-1.10524",
  "magpie-lib": "static-1.5718",
  "navigation-messaging": "static-1.8039",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.22634",
  "copilot-toolkit": "static-1.11742",
  "cms-field-types": "static-1.5062",
  "content-icons-ui": "static-1.2310",
  "integrations-lib": "static-1.16926",
  "calling-global-api": "static-1.65368",
  "calling-internal-common": "static-1.31562",
  "calling-lifecycle-internal": "static-1.66750",
  "calling-lifecycle-messages": "static-1.59044",
  "commerce-products-lib": "static-1.10406",
  "crm-index-visualization-core": "static-1.4474",
  "crm-links": "static-1.6569",
  "customer-data-properties-shared-msw-handlers": "static-1.9853",
  "file-manager-components": "static-1.24362",
  "formula-editor": "static-1.14674",
  "google-libphonenumber": "static-1.42",
  "inbounddb-objects-service-types": "static-1.4386",
  "meetings-icalendar-utils-lib": "static-1.883",
  "object-builder-ui-client": "static-1.49530",
  "pipeline-validation-client-types": "static-1.4144",
  "property-value-citations": "static-1.3040",
  "smart-property-lib": "static-1.8165",
  "tiered-pricing": "static-1.1858",
  "trial-components-library": "static-1.14022",
  "topics-actions-lib": "static-1.408",
  "ui-addon-iframeable": "static-1.9323",
  "zustand": "static-1.79",
  "final-form": "static-1.75",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.75",
  "rich-text-lib": "static-1.20235",
  "tinymce-themes": "static-1.56969",
  "data-token-picker": "static-1.16813",
  "hub-http-contrib": "static-1.3286",
  "interframe": "static-3.5004",
  "tinymce-data": "static-1.41084",
  "tinymce-plugins": "static-1.58113",
  "ui-addon-sales-email": "static-1.5461",
  "framework-data-schema-quick-fetch": "static-1.7046",
  "ui-addon-opt": "static-4.8610",
  "hubspot-apollo-cache": "static-1.584",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.422",
  "purchase-motions-api": "static-1.6285",
  "onboarding-data-sync-lib": "static-1.2403",
  "growth-onboarding-next-action-components": "static-1.2622",
  "user-context-client": "static-1.4754",
  "idb-keyval": "static-1.48",
  "magpie-types": "static-1.5178",
  "nest": "static-1.483",
  "reactive-lib": "static-1.968",
  "simple-logging-lib": "static-1.3296",
  "unified-auth-core-lib": "static-1.1083",
  "getting-started-shared-tasks-store": "static-1.18230",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1569",
  "integrations-error-boundary-lib": "static-1.14341",
  "integrations-tracking-lib": "static-1.5855",
  "native-integrations-shared-strings": "static-1.8024",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10613",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.801",
  "calling-error-reporting": "static-1.31569",
  "shared-worker-versioning": "static-1.11288",
  "calling-usage-tracker": "static-1.6785",
  "voice-sms-access-library": "static-1.1908",
  "customer-data-tracking": "static-1.7129",
  "commerce-permissions": "static-1.1024",
  "products-iframe-lib": "static-1.8496",
  "products-ui-components-shared-msw-handlers": "static-1.10908",
  "crm-index-associations-lib": "static-1.6689",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10609",
  "sales-views-client-types": "static-1.4504",
  "location-customization-utils-lib": "static-1.9989",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4398",
  "video-components-external": "static-1.12055",
  "video-data-lib": "static-1.35713",
  "bark-lib": "static-1.16753",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.99",
  "crm-properties-common-lib": "static-1.6136",
  "react-codemirror": "static-1.10887",
  "data-agent-kit": "static-1.573",
  "feedback-loader": "static-1.29734",
  "fsm": "static-1.3986",
  "policy-lib": "static-1.7041",
  "react-colorpicker": "static-2.10454",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10672",
  "embedded-academy-lib": "static-1.15342",
  "hubs-service-types": "static-1.1504",
  "FileManagerLib": "static-1.40002",
  "NamespacedHubStyle": "static-2.9224",
  "FileManagerCore": "static-1.39861",
  "content-assistance-lib": "static-1.8130",
  "layout-dnd-components": "static-1.12890",
  "layout-dnd-utils": "static-1.11865",
  "ui-addon-emoji-picker": "static-1.10132",
  "ui-brand-identity-lib": "static-1.16219",
  "InboxConnectUtils": "static-4.15457",
  "meetings-connect-utils-lib": "static-1.7855",
  "breeze-engine-chat-components": "static-1.547",
  "breeze-engine-core": "static-1.847",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "universal-page-editor-lib": "static-1.3256",
  "adobe-sign-auth-lib": "static-1.353",
  "ads-unified-auth-lib": "static-1.1042",
  "google-sheets-integration-lib": "static-1.928",
  "microsoft-drive-auth-lib": "static-1.20",
  "surveymonkey-integration-lib": "static-1.373",
  "slack-ui-library": "static-1.10644",
  "calling-orchestration-schema": "static-1.36685",
  "crm-record-cards-service-types": "static-1.3757",
  "content-media-composition-data-lib": "static-1.13111",
  "content-media-compositions": "static-2.17118",
  "media-bridge-lib": "static-1.19335",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16264",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4757",
  "storybook-react": "static-1.37",
  "academy-common-lib": "static-1.14802",
  "audio-components": "static-1.6272",
  "FileManagerImages": "static-1.37513",
  "video-components": "static-1.14057",
  "breeze-artifacts-sdk": "static-1.187",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4780",
  "video-embed": "static-1.36547",
  "ui-addon-video-player": "static-1.8952",
  "ui-coaching-tips": "static-1.29212",
  "ContentData": "static-1.69129",
  "layout-data-lib": "static-1.10190",
  "academy-service-client": "static-1.3936",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4651",
  "trellis-ecosystem": "static-1.7556",
  "ui-addon-react-router-dom": "static-1.9781",
  "wootric-nps": "static-1.7161",
  "social-insights-client-types": "static-1.22685",
  "outpost": "static-1.4408",
  "growth-onboarding-feedback-components": "static-1.6830",
  "advanced-menus-core": "static-1.15510",
  "advanced-menus-lib": "static-1.12391",
  "ExportDialog": "static-6.10627",
  "ui-memberships-settings-lib": "static-1.34713",
  "marketplace-ui-apps-core": "static-1.19131",
  "marketplace-ui-common": "static-1.20599",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15509",
  "simple-menus-lib": "static-1.17026",
  "developer-experience-shared-components": "static-1.10747",
  "immutable-less": "static-1.4898",
  "marketplace-ui-client-types": "static-1.18006",
  "ui-addon-integrations-directory-panel": "static-2.8273",
  "ui-extensibility-client-types": "static-1.4167",
  "ai-settings-ui-library": "static-1.8254",
  "nav-meta": "static-1.30349",
  "ui-product-approvals-common": "static-1.881",
  "apps-service-types": "static-1.3995",
  "oauth-service-types": "static-1.4502",
  "simple-data-table": "static-1.3435"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35115",
  "atom": "/atom/static-1.5331",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2744",
  "client-types": "/client-types/static-1.490",
  "cssUtils": "/cssUtils/static-1.870",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40757",
  "customer-data-objects": "/customer-data-objects/static-1.7934",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8345",
  "documents-lib": "/documents-lib/static-1.35120",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.360",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86478",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4973",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2419",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.108",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5843",
  "hs-test-utils": "/hs-test-utils/static-1.8274",
  "hub-http": "/hub-http/static-1.6459",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyle": "/HubStyle/static-2.12037",
  "HubStyleTokens": "/HubStyleTokens/static-2.11730",
  "I18n": "/I18n/static-7.1661",
  "icons": "/icons/static-2.674",
  "jasmine-immutable": "/jasmine-immutable/static-1.3270",
  "jasmine-runner": "/jasmine-runner/static-1.6696",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7399",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3144",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5641",
  "quartz": "/quartz/static-1.7366",
  "react": "/react/static-7.190",
  "react-dlb": "/react-dlb/static-1.84",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1-unify-reporter-duration-calculations.6",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5516",
  "react-virtualized": "/react-virtualized/static-2.104",
  "reference-resolvers": "/reference-resolvers/static-1.8429",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8346",
  "reporting-data": "/reporting-data/static-1.68579",
  "reporting-reports": "/reporting-reports/static-1.68257",
  "reporting-snowflake": "/reporting-snowflake/static-1.57197",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10512",
  "reporting-visualizations": "/reporting-visualizations/static-1.60655",
  "reselect": "/reselect/static-3.9",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9195",
  "sanitize": "/sanitize/static-1.4722",
  "sanitize-text": "/sanitize-text/static-1.8397",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1993",
  "signup-constants": "/signup-constants/static-1.19490",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8306",
  "StyleGuideUI": "/StyleGuideUI/static-3.495",
  "superstore": "/superstore/static-1.5005",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5003",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11233",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11343",
  "ui-images": "/ui-images/static-2.1229",
  "UIComponents": "/UIComponents/static-3.8676",
  "usage-tracker": "/usage-tracker/static-1.7603",
  "usage-tracker-container": "/usage-tracker-container/static-1.7593",
  "usage-tracker-core": "/usage-tracker-core/static-1.7453",
  "viral-links-lib": "/viral-links-lib/static-1.7321",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9904",
  "foundations-components": "/foundations-components/static-1.8386",
  "immutable": "/immutable/static-2.83",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1144",
  "quartz-core": "/quartz-core/static-1.6585",
  "quick-fetch": "/quick-fetch/static-1.4093",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.76",
  "redux-thunk": "/redux-thunk/static-2.77",
  "rpc-client-utils": "/rpc-client-utils/static-1.4909",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11393",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18319",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3575",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3643",
  "quartz-webpack": "/quartz-webpack/static-1.3590",
  "foundations-assets": "/foundations-assets/static-1.5123",
  "foundations-theming": "/foundations-theming/static-1.4703",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10526",
  "hubspotter-http": "/hubspotter-http/static-1.4825",
  "sassPrefix": "/sassPrefix/static-1.161",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7495",
  "crm-message-bus": "/crm-message-bus/static-1.43640",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23192",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13277",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13427",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10073",
  "events-data-lib": "/events-data-lib/static-1.489",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4182",
  "hs-resources": "/hs-resources/static-1.437",
  "immer": "/immer/static-1.94",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4018",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1243",
  "onboarding-scopes": "/onboarding-scopes/static-1.6704",
  "onboarding-tours": "/onboarding-tours/static-1.17039",
  "pulse": "/pulse/static-1.873",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14365",
  "stylex": "/stylex/static-1.38",
  "trellis-assets": "/trellis-assets/static-1.2469",
  "trellis-components": "/trellis-components/static-1.2488",
  "trellis-theming": "/trellis-theming/static-1.1208",
  "ui-addon-teams": "/ui-addon-teams/static-1.21853",
  "quartz-auth": "/quartz-auth/static-1.1041",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9329",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5289",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9580",
  "ContentUtils": "/ContentUtils/static-1.69054",
  "customer-data-properties": "/customer-data-properties/static-1.52426",
  "forms-ai-lib": "/forms-ai-lib/static-1.4687",
  "forms-utils-lib": "/forms-utils-lib/static-1.13018",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5869",
  "react-dnd-compat": "/react-dnd-compat/static-1.4863",
  "react-tinymce": "/react-tinymce/static-1.55873",
  "tinymce-config": "/tinymce-config/static-2.54999",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10601",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3688",
  "HeadJS": "/HeadJS/static-2.789",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3385",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "hs-locale-management": "/hs-locale-management/static-1.255",
  "ui-fonts": "/ui-fonts/static-1.992",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4565",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1031",
  "web-vitals": "/web-vitals/static-1.11",
  "batch-promise": "/batch-promise/static-1.1791",
  "external-options-client-types": "/external-options-client-types/static-1.4301",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7141",
  "quartz-i18n": "/quartz-i18n/static-1.1041",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8174",
  "graphql": "/graphql/static-1.86",
  "persist-promise": "/persist-promise/static-1.3948",
  "reporting-client-types": "/reporting-client-types/static-1.2651",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.90",
  "growth-payments-core": "/growth-payments-core/static-1.26072",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5125",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1411",
  "quartz-routing": "/quartz-routing/static-1.796",
  "hs-story-utils": "/hs-story-utils/static-1.9674",
  "react-flip-move": "/react-flip-move/static-1.75",
  "nested-table": "/nested-table/static-1.480",
  "seat-types-lib": "/seat-types-lib/static-1.611",
  "timezone-utils": "/timezone-utils/static-2.5495",
  "react-create-root-preference": "/react-create-root-preference/static-1.60",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4655",
  "floating-ui": "/floating-ui/static-1.61",
  "react-aria": "/react-aria/static-1.70",
  "tanstack-table": "/tanstack-table/static-1.59",
  "dispatcher": "/dispatcher/static-1.141",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.867",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.565",
  "module-federation": "/module-federation/static-1.30",
  "quartz-test": "/quartz-test/static-1.1041",
  "quartz-tracking": "/quartz-tracking/static-1.745",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.319",
  "chirp-fetch": "/chirp-fetch/static-1.2138",
  "merchandise-lib": "/merchandise-lib/static-1.273",
  "purchase-motions-components": "/purchase-motions-components/static-1.6282",
  "salesImages": "/salesImages/static-1.530",
  "ts-schema": "/ts-schema/static-1.4255",
  "bender-build-tools": "/bender-build-tools/static-1.3358",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3186",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1553",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4903",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3976",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4309",
  "event-emitter": "/event-emitter/static-1.1201",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.260",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3869",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19112",
  "growth-data-modal": "/growth-data-modal/static-1.5818",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3308",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2594",
  "navigation-components": "/navigation-components/static-1.18712",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5253",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1105",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10510",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7891",
  "ui-universal-auth": "/ui-universal-auth/static-1.9287",
  "user-context": "/user-context/static-1.5359",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.376",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10524",
  "magpie-lib": "/magpie-lib/static-1.5718",
  "navigation-messaging": "/navigation-messaging/static-1.8039",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.22634",
  "copilot-toolkit": "/copilot-toolkit/static-1.11742",
  "cms-field-types": "/cms-field-types/static-1.5062",
  "content-icons-ui": "/content-icons-ui/static-1.2310",
  "integrations-lib": "/integrations-lib/static-1.16926",
  "calling-global-api": "/calling-global-api/static-1.65368",
  "calling-internal-common": "/calling-internal-common/static-1.31562",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66750",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59044",
  "commerce-products-lib": "/commerce-products-lib/static-1.10406",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4474",
  "crm-links": "/crm-links/static-1.6569",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9853",
  "file-manager-components": "/file-manager-components/static-1.24362",
  "formula-editor": "/formula-editor/static-1.14674",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4386",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.883",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49530",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4144",
  "property-value-citations": "/property-value-citations/static-1.3040",
  "smart-property-lib": "/smart-property-lib/static-1.8165",
  "tiered-pricing": "/tiered-pricing/static-1.1858",
  "trial-components-library": "/trial-components-library/static-1.14022",
  "topics-actions-lib": "/topics-actions-lib/static-1.408",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9323",
  "zustand": "/zustand/static-1.79",
  "final-form": "/final-form/static-1.75",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "rich-text-lib": "/rich-text-lib/static-1.20235",
  "tinymce-themes": "/tinymce-themes/static-1.56969",
  "data-token-picker": "/data-token-picker/static-1.16813",
  "hub-http-contrib": "/hub-http-contrib/static-1.3286",
  "interframe": "/interframe/static-3.5004",
  "tinymce-data": "/tinymce-data/static-1.41084",
  "tinymce-plugins": "/tinymce-plugins/static-1.58113",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5461",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7046",
  "ui-addon-opt": "/ui-addon-opt/static-4.8610",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.584",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.422",
  "purchase-motions-api": "/purchase-motions-api/static-1.6285",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2403",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2622",
  "user-context-client": "/user-context-client/static-1.4754",
  "idb-keyval": "/idb-keyval/static-1.48",
  "magpie-types": "/magpie-types/static-1.5178",
  "nest": "/nest/static-1.483",
  "reactive-lib": "/reactive-lib/static-1.968",
  "simple-logging-lib": "/simple-logging-lib/static-1.3296",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1083",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18230",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1569",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14341",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5855",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8024",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10613",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.801",
  "calling-error-reporting": "/calling-error-reporting/static-1.31569",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11288",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6785",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1908",
  "customer-data-tracking": "/customer-data-tracking/static-1.7129",
  "commerce-permissions": "/commerce-permissions/static-1.1024",
  "products-iframe-lib": "/products-iframe-lib/static-1.8496",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10908",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6689",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10609",
  "sales-views-client-types": "/sales-views-client-types/static-1.4504",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9989",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4398",
  "video-components-external": "/video-components-external/static-1.12055",
  "video-data-lib": "/video-data-lib/static-1.35713",
  "bark-lib": "/bark-lib/static-1.16753",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.99",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6136",
  "react-codemirror": "/react-codemirror/static-1.10887",
  "data-agent-kit": "/data-agent-kit/static-1.573",
  "feedback-loader": "/feedback-loader/static-1.29734",
  "fsm": "/fsm/static-1.3986",
  "policy-lib": "/policy-lib/static-1.7041",
  "react-colorpicker": "/react-colorpicker/static-2.10454",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10672",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15342",
  "hubs-service-types": "/hubs-service-types/static-1.1504",
  "FileManagerLib": "/FileManagerLib/static-1.40002",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9224",
  "FileManagerCore": "/FileManagerCore/static-1.39861",
  "content-assistance-lib": "/content-assistance-lib/static-1.8130",
  "layout-dnd-components": "/layout-dnd-components/static-1.12890",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11865",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10132",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16219",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15457",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7855",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.547",
  "breeze-engine-core": "/breeze-engine-core/static-1.847",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3256",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.353",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1042",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.928",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.20",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.373",
  "slack-ui-library": "/slack-ui-library/static-1.10644",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36685",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3757",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13111",
  "content-media-compositions": "/content-media-compositions/static-2.17118",
  "media-bridge-lib": "/media-bridge-lib/static-1.19335",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16264",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4757",
  "storybook-react": "/storybook-react/static-1.37",
  "academy-common-lib": "/academy-common-lib/static-1.14802",
  "audio-components": "/audio-components/static-1.6272",
  "FileManagerImages": "/FileManagerImages/static-1.37513",
  "video-components": "/video-components/static-1.14057",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.187",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4780",
  "video-embed": "/video-embed/static-1.36547",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8952",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29212",
  "ContentData": "/ContentData/static-1.69129",
  "layout-data-lib": "/layout-data-lib/static-1.10190",
  "academy-service-client": "/academy-service-client/static-1.3936",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4651",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7556",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9781",
  "wootric-nps": "/wootric-nps/static-1.7161",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "outpost": "/outpost/static-1.4408",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6830",
  "advanced-menus-core": "/advanced-menus-core/static-1.15510",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12391",
  "ExportDialog": "/ExportDialog/static-6.10627",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34713",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19131",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20599",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15509",
  "simple-menus-lib": "/simple-menus-lib/static-1.17026",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10747",
  "immutable-less": "/immutable-less/static-1.4898",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18006",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8273",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4167",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8254",
  "nav-meta": "/nav-meta/static-1.30349",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.881",
  "apps-service-types": "/apps-service-types/static-1.3995",
  "oauth-service-types": "/oauth-service-types/static-1.4502",
  "simple-data-table": "/simple-data-table/static-1.3435"
}
};
